import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { ICustomerAppsConfig } from '../config/config.module';
import { Invoice } from './invoice';
import { DataResult, mapDataResult$ } from '../http/httpDataResponse';

type Params =
  | HttpParams
  | {
      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };

@Injectable({
  providedIn: 'root',
})
export class AccountingService {
  constructor(private httpClient: HttpClient, private configService: ConfigService<ICustomerAppsConfig>) {}

  getInvoices(params?: Params): Observable<Invoice[]> {
    return this.httpClient
      .get<DataResult<Invoice[]>>(`${this.configService.config.apiUrl}/invoices`, { params })
      .pipe(mapDataResult$());
  }

  getTaxCertificates(params?: Params): Observable<Invoice[]> {
    return this.httpClient
      .get<DataResult<Invoice[]>>(`${this.configService.config.apiUrl}/tax-certificates`, { params })
      .pipe(mapDataResult$());
  }

  countUnread(receipts: Invoice[]): number {
    return receipts.reduce((unreadCount: number, invoice: Invoice) => {
      if (!invoice.downloadedByMember) {
        unreadCount++;
      }

      if (invoice.dunning?.length > 0) {
        unreadCount = unreadCount + this.countUnread(invoice.dunning);
      }

      return unreadCount;
    }, 0);
  }
}
